import React, { useEffect, useState } from 'react';
import './style.scss';
import { ReactComponent as Logo } from '../../../assets/svg/ingame-logo-n.svg';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store/reducers';
import { getLogout } from '../../../api';
import { getLoginToken, jumpToLogin, onToHomePage } from '../../lib';
import { isConsoleRoute, isDocumentRoute } from '../../game-content/lib';
import { AccountCenter } from '../../user/account-center';
import { useHistory } from 'react-router-dom';
import {
  getLocaleLanguage,
  getLocationSearchParam,
  LanguageType,
} from '../../../lib';
import { getConfig } from '../../../config';
import getFormatMessage from '../../../locales/get-format-message';
import { ItemSiteSwitchComponent } from '../../component/header/item-site-switch';
import { ItemHelperComponent } from '../../component/header/item-helper';
import { ItemUserComponent } from '../../component/header/item-user';
import { ItemMessageComponent } from '../../component/header/item-message';
import { Button } from 'antd';
import { GlobalNotification } from '../../component/global-notification';
import { ProductsHoverComponent } from './products-hover';
import { LanguageType as Lang } from '../../../model';
import UserIcon from '../../../assets/svg/user-icon.svg';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';
import { Dispatch } from 'redux';
import { isMobile } from '../../../lib/mobile';

interface IProps {
  readonly fixedMenu?: boolean;
  readonly isHoverLeftSide?: boolean;
  readonly renderGameFilterNode?: React.ReactNode;
  readonly isTransparent?: boolean;
  readonly lang?: Lang | null;
}

export const Header = (props: IProps) => {
  const commonDispatch = useDispatch<Dispatch<CommonAction>>();
  const history = useHistory();
  const websiteURL = getConfig()?.websiteURL;
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const [showAccountCenter, setShowAccountCenter] = useState<boolean>(false);
  const [showNavMore, setShowNavMore] = useState<boolean>(false);
  const [curNavId, setCurNavId] = useState<string>(location.pathname);
  const updateSetting = () => {
    setShowNavMore(!showNavMore);
  };
  const updateNav = (path: string) => {
    setCurNavId(path);
  };

  // 文档中心传来的语言
  let lang = null;
  if (props.lang) {
    if (props.lang === Lang.ZH) {
      lang = LanguageType.zh_CN;
    } else {
      lang = LanguageType.en_US;
    }
  }
  const currentLanguage = lang || getLocaleLanguage();
  const ingameLanguage = encodeURIComponent(
    currentLanguage || LanguageType.en_US
  );
  const isConsole = isConsoleRoute();
  const isDocument = isDocumentRoute();

  useEffect(() => {
    initialization();
  }, []);

  const initialization = () => {
    initShowDefaultAccountCenter();
  };

  // notice: this is one time display
  // current user account center not page view, it is modal pop
  // need compatible with enter from website scenes, because account center undefined router
  // current website source referer only exist param (show-account-center), so replace root pathname
  const initShowDefaultAccountCenter = () => {
    const showAccountCenter = !!getLocationSearchParam('show-account-center');
    if (showAccountCenter) {
      setShowAccountCenter(showAccountCenter);
      history.replace('/');
    }
  };

  const onLogout = async () => {
    const res = await getLogout();
    if (res) {
      // jumpToLogin();
      commonDispatch({
        type: ReduxCommonActionType.LOGOUT,
      });
      location.reload();
    }
    return !!res;
  };

  const onAccountCenter = async () => {
    setShowAccountCenter(true);
  };

  const onAccountClose = () => {
    const firstElement = document.querySelector(
      '.document-headline'
    ) as HTMLElement;
    if (firstElement) {
      firstElement.style.position = 'relative';
    }
    setShowAccountCenter(false);
  };

  const renderRightActions = () => {
    return (
      <div className="col-right">
        <ul className="header-actions">
          {!isDocument ? <ItemSiteSwitchComponent /> : null}
          <ItemHelperComponent lang={currentLanguage} />
          {userInfo ? <ItemMessageComponent lang={currentLanguage} /> : null}
          {/* <ItemMessageComponent /> */}
          {userInfo ? (
            <ItemUserComponent
              userInfo={userInfo}
              onLogout={onLogout}
              onAccountCenter={onAccountCenter}
              noDownloadCenter={true}
              lang={currentLanguage}
            />
          ) : (
            <li>
              <a className="action-item" onClick={jumpToLogin}>
                {/* <span className="action-icon"> */}
                <img src={UserIcon} className="login-action-icon" />
                {/* </span> */}
              </a>
            </li>
          )}
          {renderDevPortal()}
        </ul>
      </div>
    );
  };

  const renderAccountCenter = () => {
    if (showAccountCenter && userInfo) {
      return <AccountCenter userInfo={userInfo} onClose={onAccountClose} />;
    }
    return null;
  };

  const renderDevPortal = () => {
    return (
      <Button
        type="primary"
        onClick={handleToConsoleClick}
        className="dev-portal-btn"
      >
        {getFormatMessage(
          'dev_portal',
          {},
          currentLanguage || LanguageType.en_US
        )}
      </Button>
    );
  };

  const renderLogo = () => {
    return (
      <div
        className={classNames('ingame-bg-box', {
          'is-transparent': props.isTransparent,
        })}
      >
        <span onClick={onToHomePage} className="ingame-bg">
          <Logo width={isMobile() ? 58 : 36} height={isMobile() ? 58 : 36} />
        </span>
      </div>
    );
  };

  const consoleURL = getConfig()?.consoleURL;
  const documentConfig = getConfig()?.documentConfig;
  const ingameModule = documentConfig.modules.find(
    (module) => module.key === 'INGAME'
  );
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  const ticket = getLoginToken();

  const handleDocumentationClick = () => {
    const pid = ingameModule?.pid[currentStoreLanguage];
    // if (ticket) {
    if (consoleURL && pid) {
      const url = `${consoleURL}/doc/detail/${pid}`;
      window.open(url, '_blank');
    }
    // } else {
    //   jumpToLogin();
    // }
  };

  const handleDownloadCenterClick = () => {
    history.push('/download/download-center');
    return;
  };

  const renderLinks = () => {
    if (isConsole) {
      return '';
    }
    return (
      <div className="header-center-links">
        <div
          className={classNames('navSetting', showNavMore && 'showNavMore')}
          onClick={updateSetting}
        ></div>
        {showNavMore && (
          <div
            className={classNames(
              'header-center-links-inner',
              'header-center-links-inner-mobile'
            )}
          >
            <div className="nav-bg-mask"></div>
            <ul className="navMainListBox">
              <li
                className={classNames(
                  'navMainListLi',
                  'productsBox',
                  (curNavId === '/' || curNavId.includes('/products')) &&
                    'curNav'
                )}
                onClick={() => updateNav('/')}
              >
                <a className={curNavId.includes('/products') ? 'active' : ''}>
                  <span>
                    {getFormatMessage(
                      'products_home',
                      {},
                      currentLanguage || LanguageType.en_US
                    )}
                  </span>
                  <div className="downIcon"></div>
                </a>
              </li>
              <li
                className={classNames(
                  'navMainListLi',
                  curNavId === '/get-started' && 'curNav'
                )}
                onClick={() => updateNav('/get-started')}
              >
                <a
                  href={`${websiteURL}/get-started?ingame_language=${ingameLanguage}`}
                  className={
                    location.pathname === '/get-started' ? 'active' : ''
                  }
                >
                  {getFormatMessage(
                    'get_started_uppercase',
                    {},
                    currentLanguage || LanguageType.en_US
                  )}
                </a>
              </li>
              <li
                className={classNames(
                  'navMainListLi',
                  curNavId.includes('/download-center') && 'curNav'
                )}
                onClick={() => updateNav('/download-center')}
              >
                <a
                  onClick={handleDownloadCenterClick}
                  className={
                    location.pathname === '/download-center' ? 'active' : ''
                  }
                >
                  {getFormatMessage(
                    'download_center',
                    {},
                    currentLanguage || LanguageType.en_US
                  )}
                </a>
              </li>
              <li
                className={classNames(
                  'navMainListLi',
                  'resourcesBox',
                  (curNavId === '/resources' ||
                    curNavId === '/roadmap' ||
                    curNavId.includes('/doc/detail')) &&
                    'curNav'
                )}
                onClick={() => updateNav('/resources')}
              >
                <a>
                  <span>
                    {getFormatMessage(
                      'resources',
                      {},
                      currentLanguage || LanguageType.en_US
                    )}
                  </span>
                  <div className="downIcon"></div>
                </a>
              </li>
            </ul>
            <div className="navMainListSubBox">
              {(curNavId === '/' || curNavId.includes('/products')) && (
                <ProductsHoverComponent
                  onClose={updateSetting}
                  lang={currentLanguage}
                />
              )}
              {(curNavId === '/resources' ||
                curNavId === '/roadmap' ||
                curNavId.includes('/doc/detail')) && (
                <div className="resourcesHoverBox">
                  <a
                    className={classNames(
                      'resourcesHoverItem',
                      location.pathname.includes('/doc/detail')
                        ? 'resourcesHoverActive'
                        : ''
                    )}
                    onClick={handleDocumentationClick}
                  >
                    {getFormatMessage(
                      'documentation_home',
                      {},
                      currentLanguage || LanguageType.en_US
                    )}
                  </a>
                  <a
                    href={`${websiteURL}/roadmap?ingame_language=${ingameLanguage}`}
                    className={classNames(
                      'resourcesHoverItem',
                      location.pathname === '/roadmap'
                        ? 'resourcesHoverActive'
                        : ''
                    )}
                  >
                    Roadmap
                  </a>
                </div>
              )}
            </div>
          </div>
        )}
        {!isConsole && isMobile() && renderLogo()}
        <div className="header-center-links-inner">
          <div className="products-box">
            <a>
              {getFormatMessage(
                'products_home',
                {},
                currentLanguage || LanguageType.en_US
              )}
              <div className="downIcon"></div>
            </a>
            <ProductsHoverComponent
              lang={currentLanguage}
              onClose={updateSetting}
            />
          </div>
          <div className="get-started-box">
            <a
              href={`${websiteURL}/get-started?ingame_language=${ingameLanguage}`}
            >
              {getFormatMessage(
                'get_started_uppercase',
                {},
                currentLanguage || LanguageType.en_US
              )}
            </a>
          </div>
          <div className="download-box">
            <span
              onClick={handleDownloadCenterClick}
              className={
                location.pathname.includes('/download-center') ? 'active' : ''
              }
            >
              {getFormatMessage(
                'download_center',
                {},
                currentLanguage || LanguageType.en_US
              )}
            </span>
          </div>
          <div className="resourcesBox">
            <a>
              <span>
                {getFormatMessage(
                  'resources',
                  {},
                  currentLanguage || LanguageType.en_US
                )}
              </span>
              <div className="downIcon"></div>
            </a>
            <div className="resourcesHoverBox">
              <a
                className={classNames(
                  'resourcesHoverItem',
                  location.pathname === '/documentation'
                    ? 'resourcesHoverActive'
                    : ''
                )}
                onClick={handleDocumentationClick}
              >
                {getFormatMessage(
                  'documentation_home',
                  {},
                  currentLanguage || LanguageType.en_US
                )}
              </a>
              <a
                href={`${websiteURL}/roadmap?ingame_language=${ingameLanguage}`}
                className={classNames(
                  'resourcesHoverItem',
                  location.pathname === '/roadmap' ? 'resourcesHoverActive' : ''
                )}
              >
                Roadmap
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderPortal = () => {
    return (
      <div className="col-title">
        {isConsole ? props.renderGameFilterNode : <div></div>}
      </div>
    );
  };

  const handleToConsoleClick = () => {
    if (ticket && consoleURL) {
      window.open('/', '_blank');
    } else {
      jumpToLogin();
    }
  };

  const className = classNames('download-center-header', {
    'fixed-menu': props.fixedMenu,
    'is-console': isConsole,
    'is-hover': props.isHoverLeftSide,
  });

  return (
    <>
      {!userInfo && isDocument ? null : (
        <GlobalNotification className="download-center-notice-bar" />
      )}
      <div
        className={classNames(
          'download-center-headline',
          isDocument ? 'document-headline' : ''
          // 'darkHeader'
        )}
      >
        {/* <GlobalNotification className="download-center-notice-bar" /> */}
        <div className={className}>
          {!isConsole && !isMobile() && renderLogo()}
          {renderLinks()}
          {renderPortal()}
          {renderRightActions()}
          {renderAccountCenter()}
        </div>
      </div>
    </>
  );
};
